import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getAcademicRequest: [],
  getAcademicSuccess: ['data'],
  getAcademicFailure: ['error'],
});

export const AcademicTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  academicDetails: [],
  academicError: {},
});

/* Reducers */

const getAcademicRequest = (state) =>
  state.merge({
    ...state,
    academicError: {},
  });

const getAcademicSuccess = (state, { data }) =>
  state.merge({
    academicDetails: data,
    academicError: {},
  });

const getAcademicFailure = (state, { error }) =>
  state.merge({
    ...state,
    academicError: { ...error },
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ACADEMIC_REQUEST]: getAcademicRequest,
  [Types.GET_ACADEMIC_SUCCESS]: getAcademicSuccess,
  [Types.GET_ACADEMIC_FAILURE]: getAcademicFailure,
});
